import { useCallback, useEffect, useState } from "react";
import { api } from "./api";

export interface FitPassSession {
  token: string;
  shareUrl: string;
  expiresAt: string;
}

export function useFitPass(enabled: boolean) {
  const [session, setSession] = useState<FitPassSession | null>(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(enabled);

  const refresh = useCallback(async () => {
    if (!enabled) {setSession(null);setLoading(false);return;}
    setLoading(true);
    setSession(null);
    setError("");
    try { setSession(await api<FitPassSession>("/fit-pass")); }
    catch (reason) { setError(reason instanceof Error ? reason.message : "FitYouX Pass unavailable"); }
    finally { setLoading(false); }
  }, [enabled]);

  useEffect(() => { void refresh(); }, [refresh]);
  useEffect(() => { if(!session)return; const delay=Date.parse(session.expiresAt)-Date.now();const timer=window.setTimeout(()=>{setSession(null);setError("Il QR è scaduto. Aggiornalo per condividerlo di nuovo.");},Math.max(0,delay));return()=>window.clearTimeout(timer); },[session]);
  return { session, error, loading, refresh };
}
